export default "__VITE_ASSET__CdOn2fzX__"